import React from 'react';
import styled from 'styled-components';

import ShoreLogoPNG from 'assets/images/shore_logo.png';
import ShoreSmallLogoPNG from 'assets/images/shore_small_logo.png';

const LogoWrapper = styled.div<Props>`
  text-align: center;
  height: 33px;
  margin: 20px;
  padding-right: ${({ collapsed }) => (collapsed ? '0' : '90px')};

  & > img {
    height: inherit;
  }
`;

interface Props {
  collapsed?: boolean;
}

const Logo: React.FC<Props> = ({ collapsed = false }) => (
  <LogoWrapper collapsed={collapsed}>
    <img src={collapsed ? ShoreSmallLogoPNG : ShoreLogoPNG} alt="Shore Logo" />
  </LogoWrapper>
);

export default Logo;
